import React, {FC} from "react";
import {useTranslation} from "react-i18next";
import {PageViewportLayout} from "../../components/template";
import {ErrorPage, ErrorPageButtons} from "../error/ErrorPage";

export const VotingEmpty: FC<{}> = ({}) => {

    const {t} = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('voting.no_voting')}
                text={t('voting.no_voting_desc')}
                buttons={ErrorPageButtons.MAIN_ONLY}
            />
        </PageViewportLayout>
    );
};import React, {FC} from "react";
import {useTranslation} from "react-i18next";
import {PageViewportLayout} from "../../components/template";
import {ErrorPage, ErrorPageButtons} from "../error/ErrorPage";

export const VotingEmpty: FC<{}> = ({}) => {

    const {t} = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('voting.no_voting')}
                text={t('voting.no_voting_desc')}
                buttons={ErrorPageButtons.MAIN_ONLY}
            />
        </PageViewportLayout>
    );
};